import { ChevronRightIcon } from "./icons";

function ShippingEditButton({ onClick }) {
  return (
    <button
      aria-label="배송정보 수정하기"
      className="photo-select-shipping-edit"
      data-action="edit-address"
      onClick={onClick}
      type="button"
    >
      <span>수정하기</span>
      <ChevronRightIcon />
    </button>
  );
}

function ShippingInfoRow({ label, address = false, children }) {
  return (
    <div className={`photo-select-shipping-row${address ? " photo-select-shipping-row-address" : ""}`}>
      <dt>{label}</dt>
      <dd>{children}</dd>
    </div>
  );
}

function ShippingInfoSection({ shippingInfo, onEdit }) {
  if (!shippingInfo) {
    return (
      <section className="photo-select-shipping">
        <div className="photo-select-shipping-header">
          <h2>배송정보</h2>
          {onEdit ? <ShippingEditButton onClick={onEdit} /> : null}
        </div>
        <p>등록된 배송지가 없습니다.</p>
      </section>
    );
  }

  const recipient = shippingInfo.recipient || shippingInfo.receiver;
  const firstAddress = shippingInfo.addressLine1 || shippingInfo.address;
  const secondAddress = shippingInfo.addressLine2 || shippingInfo.detailAddress;

  return (
    <section className="photo-select-shipping" data-node-id="6368:6160">
      <div className="photo-select-shipping-header">
        <h2>배송정보</h2>
        {onEdit ? <ShippingEditButton onClick={onEdit} /> : null}
      </div>

      <dl className="photo-select-shipping-list">
        <ShippingInfoRow label="받으시는 분">{recipient || "정보 없음"}</ShippingInfoRow>
        <ShippingInfoRow label="배송지" address>
          <span>{firstAddress || "정보 없음"}</span>
          {secondAddress ? <span>{secondAddress}</span> : null}
        </ShippingInfoRow>
        <ShippingInfoRow label="연락처">{shippingInfo.phone || "정보 없음"}</ShippingInfoRow>
      </dl>
    </section>
  );
}

export { ShippingEditButton, ShippingInfoRow, ShippingInfoSection };
